<template>
  <div class="app-shell">
    <AuthTopNav />
    <router-view></router-view>
    <footer class="app-footer glass-card">
      <a href="https://tauchschule-h2o.ch" target="_blank" rel="noopener" class="footer-logo-link">
        <img src="/h2oLogoBlack.svg" alt="H₂O logo" class="footer-logo footer-logo--dark">
        <img src="/h2oLogoWhite.svg" alt="H₂O logo" class="footer-logo footer-logo--light">
      </a>
        <h1 class="text-center mt-4">{{ $t('main.title') }}</h1>
      <div class="footer-meta">
        <p class="footer-copy mb-0">
          Copyright © {{ new Date().getFullYear() }} 
          <a href="https://elektroptiker.ch" target="_blank" rel="noopener">Daniel Gallati</a>
        </p>
        <p class="footer-build mb-0">Build {{ buildNumber }}</p>
      </div>
    </footer>
  </div>
</template>
 
<script>
import AuthTopNav from './components/AuthTopNav.vue';

export default {
  name: 'App',
  components: {
    AuthTopNav,
  },
  computed: {
    buildNumber() {
      const explicitBuild = process.env.VUE_APP_BUILD_NUMBER || process.env.VUE_APP_BUILD;
      if (explicitBuild) return String(explicitBuild);
      return process.env.NODE_ENV === 'production' ? 'prod-local' : 'dev-local';
    }
  }
};
</script>

<style>
.app-shell {
  color: var(--h2o-text);
  font-family: 'Manrope', 'Nunito Sans', 'Avenir Next', sans-serif;
  padding-top: env(safe-area-inset-top, 0px);
  padding-bottom: 20px;
}

.app-footer {
  max-width: min(1160px, calc(100% - 16px));
  margin: 28px auto 10px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.footer-logo {
  height: 50px;
  width: auto;
  display: block;
}

.footer-logo--light {
  display: none;
}

:root[data-theme='light'] .footer-logo--dark {
  display: none;
}

:root[data-theme='light'] .footer-logo--light {
  display: block;
}

.footer-copy {
  color: var(--h2o-text-soft);
  font-size: 0.6rem;
}
.footer-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.footer-build {
  color: var(--h2o-text-faint);
  font-size: 0.48rem;
  line-height: 1;
  letter-spacing: 0.02em;
  margin-top: 3px;
}
.footer-copy a, a:visited, a:hover, a:active {
  color: var(--h2o-primary-strong);
  text-decoration: none;
}

@media (max-width: 760px) {
  .app-footer {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-meta {
    align-items: flex-start;
  }
}
</style>
